import http from './http'
const base = '/Telas/AjustePagamento'
export default {
  async get () { return (await http.get(`${base}/Get`)).data },
  async getByPayment (id) { return (await http.get(`${base}/GetByPayment/${id}`)).data },
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async add (paymentId, input) { return (await http.post(`${base}/Add/${paymentId}`, input)).data }
}
